<template>
    <div class="space-x-1 space-y-1 mt-1">
        <div class="inline-block rounded-md py-1 px-2 bg-gray-100 text-gray-600 text-xs cursor-pointer transition-all hover:bg-gray-200" v-for="(name, index) in options" :key="index" @click="$emit('select', index)">
            {{ name }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            options: {
                '@hourly': this.__('admin::scripts.frequency_hourly'),
                '@hourly:8-23': this.__('admin::scripts.frequency_hourly_8_23'),
                '@daily': this.__('admin::scripts.frequency_daily'),
                '@monthly': this.__('admin::scripts.frequency_monthly'),
            },
        };
    },
}
</script>
